import React from 'react';

/* eslint-disable no-tabs */
export default function currentActiveStep(
	userData = {},
	exclaimation = false,
	loading = false,
	hasWallet = false,
	submission_date = false,
	pending = false,
	approved = false
) {
	if (
		(submission_date && pending) ||
		(userData?.kyc_status === 'Rejected' &&
			!userData?.kyc_resubmission_date &&
			!userData?.send_email_resubmission_result)
	) {
		return {
			active_step: 2,
			message: loading ? (
				'Checking your status ... '
			) : (
				<span>
					Identity Verification Submitted <br /> Wait for approval or resubmit if rejected
				</span>
			)
		};
	} else if (
		(submission_date && approved) ||
		(userData?.kyc_status === 'Rejected' &&
			((userData?.kyc_resubmission_date && !userData?.send_email_resubmission_result) ||
				(userData?.kyc_resubmission_date && userData?.send_email_resubmission_result)))
	) {
		return {
			active_step: 3,
			message: loading ? (
				'Checking your status ... '
			) : approved ? (
				<span>
					Identity Verification Approved <br /> Start a new loan or view your loans
				</span>
			) : (
				<span>
					Identity Verification Resubmitted <br /> Wait for approval or resubmit if rejected
				</span>
			)
		};
	} else {
		return {
			active_step: 1,
			message: loading ? (
				'Checking your status ... '
			) : hasWallet && !submission_date ? (
				<span>
					Account Created <br /> Wallet created! Please complete your identity verification
				</span>
			) : (
				<span>
					Account Created <br /> Please create your wallet then complete your identity verification
				</span>
			)
		};
	}
}
